import { checkMobile } from './utils/checkMobile';
const isMobile = checkMobile();

export const SETTINGS = {
  fps: 30,
  debug: {
    physics: true,
  },
  // Three.js
  camera: {
    fov: 75,
    aspect: 1,
    near: 0.1,
    far: 1000,
    position: {
      x: isMobile ? 3.5 : 3.0,
      y: isMobile ? 6.0 : 5,
      z: 0,
    },
    lookAt: {
      x: 0,
      y: 0,
      z: 0,
    }
  },
  count: {
    circleLines: 3,
    lightLines: 3,
    landmarks: 20,
  }
}

export const SPHERE_COLORS = [
  '#ffffff',
];

export const LINE_COLORS = [
  '#3Ec0FF',
  '#0E60aa',
  '#5E90fa',
  '#5Ea07F',
  '#2Ea09F',
];

export const CIRCLE_LINE_COLORS = [
  '#FF8C00',
];
